<template>
    <div class="custom-table-container">
        <div v-if="title || $slots['title-actions']" class="table-header">
            <div v-if="title" class="table-title">{{ title }}</div>
            <div v-if="$slots['title-actions']" class="title-actions">
                <slot name="title-actions"></slot>
            </div>
        </div>
        <div class="table-content">
            <div :class="tab ? 'tab' : 'btn-table'" v-if="hideBtnTable === false">
                <slot name="btn-table"></slot>
            </div>
            <div
                class="table-wrapper"
                :style="
                    tableModal
                        ? { 'max-height': wrapperHeight }
                        : { height: wrapperHeight }
                "
            >
                <table>
                    <thead class="text-center">
                        <slot name="header"></slot>
                    </thead>
                    <tbody class="text-center">
                        <slot name="body"></slot>
<tr v-if="!hasBodySlotContent">
    <td colspan="100" class="empty-data-cell">Không có bản ghi nào.</td>
</tr>
                    </tbody>
                </table>
            </div>
            <div class="pagi" v-if="hidePagi === false">
                <slot name="pagi"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tableModal: {
            type: Boolean,
            default: false
        },
        hidePagi: {
            type: Boolean
        },
        hideBtnTable: {
            type: Boolean
        },
        columnForm: {
            type: Number,
            default: 1
        },
        tab: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false,
            resizing: null
        }
    },

    mounted() {
        // Sử dụng setTimeout để đảm bảo slot content đã được render hoàn toàn
        setTimeout(() => {
            this.initResizableColumns()
        }, 100)
    },

    updated() {
        // Re-init khi component update (ví dụ khi data thay đổi)
        setTimeout(() => {
            this.initResizableColumns()
        }, 100)
    },

    beforeDestroy() {
        // Cleanup event listeners
        document.removeEventListener('mousemove', this.handleMouseMove)
        document.removeEventListener('mouseup', this.handleMouseUp)
    },

    methods: {
        initResizableColumns() {
            const table = this.$el.querySelector('table')
            if (!table) return

            const headers = table.querySelectorAll('thead th')

            headers.forEach((th) => {
                // Kiểm tra nếu đã có resize handle rồi thì không tạo nữa
                if (th.querySelector('.resize-handle')) {
                    return
                }

                th.classList.add('resizable')

                // Tạo resize handle
                const resizeHandle = document.createElement('div')
                resizeHandle.className = 'resize-handle'
                resizeHandle.setAttribute('title', 'Kéo để thay đổi độ rộng cột')

                th.appendChild(resizeHandle)

                // Xử lý sự kiện resize
                resizeHandle.addEventListener('mousedown', (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    this.resizing = {
                        th: th,
                        startX: e.pageX,
                        startWidth: th.offsetWidth
                    }

                    document.addEventListener('mousemove', this.handleMouseMove)
                    document.addEventListener('mouseup', this.handleMouseUp)
                })
            })
        },

        handleMouseMove(e) {
            if (!this.resizing) return

            const newWidth =
                this.resizing.startWidth + (e.pageX - this.resizing.startX)

            // Độ rộng tối thiểu là 50px
            if (newWidth > 50) {
                // CHỈ thay đổi width, KHÔNG động vào height
                this.resizing.th.style.width = newWidth + 'px'
                this.resizing.th.style.minWidth = newWidth + 'px'
                this.resizing.th.style.maxWidth = newWidth + 'px'
            }
        },

        handleMouseUp() {
            this.resizing = null
            document.removeEventListener('mousemove', this.handleMouseMove)
            document.removeEventListener('mouseup', this.handleMouseUp)
        }
    },

    computed: {
        toggleDisplay() {
            return this.$store.state.toggleDisplay.toggleDisplay
        },
        zoom() {
            return this.$store.state.zoom.zoom
        },
        /* 100vh - chiều cao header - chiều cao navbar - chiều cao toolbar - hrtable - btnTable - chiều cao formsearch  - chiều cao pagi */
        wrapperHeight() {
            const additionalHeight = ' - 50px'
            const heightColumnForm = additionalHeight.repeat(this.columnForm - 1)

            const toggleHeight = heightColumnForm + ' - 70px' // 70px là chiều cao ban đầu của form-search

            const convertToggleHeight =
                toggleHeight
                    .split(' ')
                    .filter((item) => !isNaN(parseInt(item)))
                    .map((item) => parseInt(item))
                    .reduce((acc, curr) => acc + curr, 0) + 'px'

            let baseHeight = this.hideBtnTable
                ? 'calc(100vh - 45px - 40px - 50px - 70px - 50px )'
                : 'calc(100vh - 45px - 40px - 50px - 2px - 40px - 70px - 50px )'

            if (this.toggleDisplay) {
                baseHeight += ' + ' + convertToggleHeight
            }
            if (this.zoom) {
                baseHeight += ' + ' + '90px'
            }

            return `calc(${baseHeight}${heightColumnForm})`
        },

        hasBodySlotContent() {
            return (
                !!this.$slots.body && this.$slots.body.some((vnode) => vnode.tag)
            )
        }
    }
}
</script>

<style scoped>
.custom-table-container {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin: 20px;
    background: #ffffff;
    padding: 20px;
}

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.table-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--black-common);
}

.title-actions {
    display: flex;
    align-items: center;
}

table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}
thead {
    position: sticky;
    top: 0;
    z-index: 1;
}
table th {
    background: var(--blue-200);
    color: #ffffff;
    font-weight: bold !important;
    font-weight: 500;
    font-size: 11pt;
    position: sticky;
    top: 0;
    z-index: 2;
    transition: background-color 0.3s ease;
}
tbody tr:hover td {
    background-color: #d0ecff;
}
tbody tr td {
    color: #212529;
}

table td,
table th {
    padding: 10px 16px;
    border-width: 0 0 1px 1px;
    border-style: solid;
    border-color: #dedede;
    font-size: 11pt;
    vertical-align: middle;
}

.empty-data-cell {
    border-bottom: none !important;
}

.table-wrapper {
    border: 1px solid #ddd;
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    scrollbar-width: thin; /* For Firefox */
}
.table-wrapper::-webkit-scrollbar {
    height: 8px; /* Height of horizontal scrollbar */
    width: 8px; /* Width of vertical scrollbar */
}

.table-wrapper::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.btn-table {
    height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.tab {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0;
}
.hr-table {
    border: 0.1px solid #ddd;
    padding: 0;
    width: 100%;
}
.text-navigate {
    color: var(--blue-200);
    cursor: pointer;
}
.text-navigate:hover {
    color: var(--black-100);
}
.text-navigate:hover {
    text-decoration: underline;
}
.text-right {
    text-align: right;
}
.pagi {
    background: var(--white-common);
    height: 50px;
    line-height: 50px;
    padding: 0px 10px 0px 0px;
}
.text-left {
    text-align: left;
}
.count {
    margin-right: 5px;
}
.icon,
.icon-dislabel {
    height: 15px;
    cursor: pointer;
    padding: 0px 10px 0px 10px;
}
.icon-dislabel {
    cursor: not-allowed !important;
    filter: invert(67%) sepia(1%) saturate(0%) hue-rotate(180deg) brightness(90%)
        contrast(90%);
}
.min-w-50 {
    min-width: 50px;
}
.min-w-75 {
    min-width: 75px;
}
.min-w-100 {
    min-width: 100px;
}
.min-w-150 {
    min-width: 150px;
}
.min-w-200 {
    min-width: 200px;
}
.min-w-250 {
    min-width: 250px;
}
.min-w-300 {
    min-width: 300px;
}
.min-w-350 {
    min-width: 350px;
}
.min-w-400 {
    min-width: 400px;
}
.min-w-500 {
    min-width: 500px;
}
.min-w-600 {
    min-width: 600px;
}
tbody tr:nth-child(even) {
    background-color: #f9f9f9;
}

tbody tr:nth-child(odd) {
    background-color: #fff;
}
tbody tr:nth-child(5n) {
    border-bottom: 2px solid #dedede;
}

/* Resize handle styling - KHÔNG dùng scoped để tránh conflict */
</style>

<style>
/* Global style cho resize handle - KHÔNG scoped */
.resize-handle {
    display: block !important;
    position: absolute !important;
    top: 0 !important;
    right: -4px !important;
    width: 8px !important;
    height: 100% !important;
    cursor: col-resize !important;
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    z-index: 99999 !important;
    background: transparent !important;
    pointer-events: auto !important;
    box-sizing: border-box !important;
}

.resize-handle:hover {
    background-color: rgba(255, 255, 255, 0.3) !important;
    border-left: 2px solid rgba(255, 255, 255, 0.8) !important;
}

.resize-handle:active {
    background-color: rgba(255, 255, 255, 0.5) !important;
    border-left: 3px solid #ffffff !important;
}

/* Override mọi CSS có thể ảnh hưởng đến th */
table th {
    position: relative !important;
    overflow: visible !important;
}
</style>
